import React, { useCallback, useEffect } from 'react';
import { Waypoint } from 'react-waypoint';
import { ListBranch, ListBranchState } from '../types-store';

interface ListItemContainerProps {
  listBranch: ListBranch;
  listBranchState: ListBranchState;
  id: number;
  loadFromParent: (id: number, startIndex: number) => void;
  children?: React.ReactNode;
}

export const ListItemsContainer: React.FC<ListItemContainerProps> = ({
  listBranch, listBranchState, id, loadFromParent, children
}) => {

  const loadCode = useCallback(
    (appendToList: boolean) => {

      if (!listBranchState?.open || listBranchState?.fetching) {
        return;
      }

      if (appendToList || !listBranch) {

        const startIndex = appendToList && listBranch?.items
          ? listBranch.items.length
          : 0;

        if (startIndex > 0 && (listBranch?.items?.length ?? 0) >= (listBranch?.numberOfResults ?? 0)) {
          return;
        }

        loadFromParent(id, startIndex);
      }
    },
    [listBranch, listBranchState, id, loadFromParent]);

  const onLoadMore = useCallback(
    () => loadCode(true),
    [loadCode]
  );

  useEffect(() => loadCode(false),
    [loadCode]
  );

  if (!listBranch?.items?.length) {
    return null;
  }

  return <div>
    {children}
    <Waypoint key={`wpLinkCodes${id}`} onEnter={onLoadMore} scrollableAncestor={window} bottomOffset="-10%" />
  </div>;
};
